import React from "react";
import logo from "../../img/logo-02.png";
import { Link } from "react-router-dom";
import { MyContext } from "../../context";
import { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom'
import supabase from "../../Supa";

function ClientNavDropMenu() {
    const { LinkSelection, updateLinkSelection, updateInstallationLinkSelection } = useContext(MyContext);
    let navigate = useNavigate()

    async function out(e){


        e.preventDefault()
    
        try {
        
      
        const { error } = await supabase.auth.signOut()
    
         
         if (error) throw error
         sessionStorage.removeItem('token')
         navigate('/')
             
        }catch(error){
         console.log(error)
        }
           
    }

    function profile(e){


        e.preventDefault()
        navigate('/dashboard')
        updateLinkSelection("Setting")
    
           
    }


  return (
    <>


                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                  style={{width:"370px", marginLeft:"-200px"}}
                >
                  <div style={{color:"#a0a0a0", paddingLeft:"25px", cursor:"default"}}><span>Account</span>
                 </div>

                
                 <hr style={{marginTop:"10px"}} />

                 <div className="dropdown-item" style={{display:"flex"}} onClick={profile}> <span class="material-symbols-rounded" style={{paddingRight:"5px"}}>person</span><span className="NavName">My Profile</span>
                 </div> 

                 <div className="dropdown-item" style={{display:"flex"}}> <span class="material-symbols-rounded" style={{paddingRight:"5px"}}>settings</span><span className="NavName">Administration</span>
                 </div> 

              




                 <div style={{color:"#a0a0a0", paddingTop:"20px", paddingLeft:"25px", cursor:"default"}}><span>Support</span>
                 </div>
                 <hr style={{marginTop:"10px"}} />


                 <a href="https://forms.monday.com/forms/8bab8b0e829844b0d2962e0e865f097c?r=use1" target="_blank" rel="noopener noreferrer">
                 <div className="dropdown-item" style={{display:"flex"}}> <span class="material-symbols-rounded" style={{paddingRight:"5px"}}>support_agent</span><span className="NavName">Log A Ticket</span>
                 </div> 
                 </a>

                 <a href="https://www.i-g3n.co.za/register-your-battery/" target="_blank" rel="noopener noreferrer">
                 <div className="dropdown-item" style={{display:"flex"}}> <span class="material-symbols-rounded" style={{paddingRight:"5px"}}>battery_unknown</span><span className="NavName">Battery Registration</span>
                 </div> </a>

                 

                 <div className="dropdown-item" style={{display:"flex"}}> <span class="material-symbols-rounded" style={{paddingRight:"5px"}}>help</span><span className="NavName">FAQ</span>
                 </div>

                <hr />
                    

                 <div className="dropdown-item" onClick={out} style={{display:"flex", paddingBottom:"20px"}}> <span class="material-symbols-rounded" style={{paddingRight:"5px"}}>logout</span><span className="NavName">Logout</span>
                 </div>

                {/*<div className="dropdown-item"><span className="NavName">{usersEmail}</span>
                 </div> */}


                </div>

    </>
  );
}

export default ClientNavDropMenu;



